

















import { Component, Vue, Provide, Watch, Prop, Emit, Model} from 'vue-property-decorator';

@Component
export default class DatePickerView extends Vue {
  @Prop({ type: String, required: false }) private type!: string;
  @Prop({ type: String, required: false }) private dpvContent!: string;
  private created() {
    // console.log(this.btnObj);
  }

  @Emit('change')
  private clickEmit(value: any) {
    return value;
  }
}
